import React from "react";
import { Col, Row } from "reactstrap";

const LoadingContent = () => {
    return (
        <div className="overview-tab">
            <Row className="mb-3">
                <Col lg="4">
                    <div className="dt-field dt-skeleton" style={{ width: "100%", height: "120px" }} />
                </Col>
                <Col lg="4">
                    <div className="dt-field dt-skeleton" style={{ width: "100%", height: "120px" }} />
                </Col>
                <Col lg="4">
                    <div className="dt-field dt-skeleton" style={{ width: "100%", height: "120px" }} />
                </Col>
            </Row>
            <Row>
                <Col lg="12">
                    <div className="dt-field dt-skeleton" style={{ width: "100%", height: "240px" }} />
                </Col>
            </Row>
        </div>
    );
};

export default LoadingContent;
